/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('jsonPath', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./json-path.html'),

      replace: true,

      scope: {
        path: '=ngModel',
      },

      link(scope, element, attrs) {
        scope.TYPES = {
          object: 'object',
          array: 'array',
          custom: 'custom',
        };

        scope.TYPES_VALUES = {
          object: '$',
          array: '$[*]',
          custom: '$.data[*]',
        };

        scope.type = scope.TYPES;

        scope.selectType = function (type) {
          scope.type = type;
          scope.path = scope.TYPES_VALUES[type];
        };

        scope.$watch('path', function (path) {
          if (path === scope.TYPES_VALUES.object) {
            scope.type = scope.TYPES.object;
          } else if (path === scope.TYPES_VALUES.array) {
            scope.type = scope.TYPES.array;
          } else {
            scope.type = scope.TYPES.custom;
          }
        });
      },
    };
  },
]);
